export const myServices = [
  {
    number: "01",
    title: "Web Product Engineering",
    text: "I turn product requirements and designs into fast, accessible React and Next.js experiences connected to real APIs—not isolated frontend demos.",
    tags: ["React", "Next.js", "TypeScript", "Product UI"],
  },
  {
    number: "02",
    title: "Backend Systems & APIs",
    text: "I design the application logic behind the interface: authentication, data models, payments, dashboards, and reliable service integrations.",
    tags: ["Node.js", "Express", "MongoDB", "API Design"],
  },
  {
    number: "03",
    title: "Cross-Platform Mobile",
    text: "I build Flutter and React Native products that carry the same quality into mobile clear flows, dependable state, cloud data, and platform-aware UX.",
    tags: ["Flutter", "React Native", "Firebase", "Mobile UX"],
  },
  {
    number: "04",
    title: "Applied AI Integration",
    text: "I integrate Gemini and OpenAI into useful workflows assistants, analysis, content generation, and automation with the surrounding product logic to make them dependable.",
    tags: ["Gemini", "OpenAI", "LangChain", "AI Workflows"],
  },
];
